import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function Wishlist() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/wishlist").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10">
      <h1 className="font-display font-black text-4xl sm:text-6xl tracking-tight">Wishlist</h1>
      {items.length === 0 ? (
        <div className="mt-10 border border-dashed border-neutral-300 p-16 text-center">
          <p className="text-neutral-600">Nothing saved yet.</p>
          <Link to="/products" className="inline-flex mt-4 text-[#0033FF] font-semibold underline">
            Explore products
          </Link>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-10">
          {items.map((p, i) => <ProductCard key={p.product_id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
